// Mock data for CCK Possibilities NEMT Landing Page

export const mockData = {
  company: {
    name: "CCK Possibilities",
    tagline: "Reliable Non-Emergency Medical Transportation You Can Trust",
    phone: "(470) 479-2055",
    email: "ccknemt1911@gmail.com",
    address: "1570 Williamson Rd STE A Griffin GA 30224"
  },
  
  hero: {
    headline: "Safe, Reliable Medical Transportation Across 16 Georgia Counties",
    subheadline: "We are a woman owned business our offices are located in Griffin GA who specializes in providing non-emergency medical transportation in a safe and efficient manner. Serving Georgia Medicaid and Medicare members, private pay, and healthcare facilities in Upson, Lamar, Pike, Butts, Spalding, Monroe, Taylor, Talbot, Harris, Meriwether, Troup, Muscogee, Coweta, Fayette, Henry, and Clayton counties.",
    cta: {
      primary: "Schedule a Ride",
      secondary: "Call Now: (470) 479-2055"
    }
  },
  
  about: {
    title: "What Is CCK Possibilities?",
    description: "We are a family owned and locally operated business who specializes in providing Non-emergency medical transportation in a safe and efficient manner. After 30 years experience in Education, Transportation, and Human Relations, we identified a need within the community for Non-emergency medical transport for the underserved & underrepresented members. We've made it our personal mission to provide safe, secure & timely transport to Georgia Medicaid & Medicare members, Private pay, and healthcare facilities. We have a commitment to be more than a driver driving a van. We treat everyone like family to ensure they enjoy their trip.",
    highlights: [
      "Fleet of well-maintained vehicles",
      "Serving Griffin, Atlanta, McDonough, and surrounding Central Georgia areas",
      "Both ambulatory and wheelchair-accessible transportation",
      "Licensed, insured, and background-checked drivers"
    ]
  },
  
  services: [
    {
      id: 1,
      title: "Medicaid Rides",
      description: "We are an approved provider for Medicaid non-emergency medical transportation services in Georgia. Our team handles the authorization process and works directly with your managed care organization.",
      icon: "shield-check",
      features: [
        "Pre-authorized Medicaid transportation",
        "Direct billing to Medicaid",
        "No out-of-pocket costs for eligible members",
        "Wheelchair-accessible vehicles available"
      ],
      cta: "Schedule Medicaid Ride",
      link: "/medicaid"
    },
    {
      id: 2,
      title: "Private Pay Services",
      description: "For those not covered by Medicaid or needing additional services, we offer competitive private pay rates. Perfect for medical appointments, hospital discharges, and wellness visits.",
      icon: "credit-card",
      features: [
        "Affordable flat rates",
        "Same-day service available",
        "Flexible scheduling",
        "Professional, courteous drivers"
      ],
      cta: "Get a Quote",
      link: "/private-pay"
    },
    {
      id: 3,
      title: "Facility & Provider Partnerships",
      description: "We partner with healthcare facilities, clinics, and providers to ensure patients arrive for their appointments. Our contracted rates are flexible with no minimum trip requirements.",
      icon: "building-2",
      features: [
        "Customized transportation solutions",
        "Volume-based pricing",
        "Dedicated account management",
        "Real-time ride tracking and reporting"
      ],
      cta: "Partner With Us",
      link: "/partnerships"
    }
  ],
  
  coverage: {
    title: "Our Service Areas",
    description: "We proudly serve 16 counties across Central Georgia with reliable medical transportation services.",
    areas: [
      "Upson County",
      "Lamar County",
      "Pike County",
      "Butts County",
      "Spalding County",
      "Monroe County",
      "Taylor County",
      "Talbot County",
      "Harris County",
      "Meriwether County",
      "Troup County",
      "Muscogee County",
      "Coweta County",
      "Fayette County",
      "Henry County",
      "Clayton County"
    ],
    note: "We also provide out-of-state transportation for specialized medical appointments."
  },
  
  testimonials: [
    {
      id: 1,
      name: "Joseph P.",
      location: "Barnsville, GA",
      rating: 5,
      text: "CCK Possibilities has been a lifesaver for getting me to my dialysis appointments three times a week. The drivers are always on time, friendly, and professional. I couldn't ask for better service!",
      service: "Medicaid Rides"
    },
    {
      id: 2,
      name: "Nautica W.",
      location: "McDonough, GA",
      rating: 5,
      text: "We have been working with Patrick for a year, and his professionalism has consistently exceeded our expectations. He is reliable, compassionate, and punctual and his vehicles are always clean and well-maintained. The front staff is equally courteous and efficient. If you are seeking dependable senior transportation services, CCK is an excellent choice.",
      service: "Private Pay"
    },
    {
      id: 3,
      name: "Dr. Jennifer M.",
      location: "Healthcare Provider",
      rating: 5,
      text: "As a clinic manager, having CCK Possibilities as our transportation partner has reduced our no-show rates significantly. Their drivers are reliable and their communication is excellent.",
      service: "Facility Partnership"
    }
  ],
  
  faq: [
    {
      id: 1,
      question: "What is NEMT?",
      answer: "NEMT stands for Non-Emergency Medical Transportation. It's a benefit that provides transportation to and from medical appointments for those who don't have access to reliable transportation."
    },
    {
      id: 2,
      question: "How do I schedule a ride?",
      answer: "You can schedule a ride by calling us at (470) 479-2055, filling out our online booking form, or contacting your Medicaid managed care organization if you're a Medicaid member."
    },
    {
      id: 3,
      question: "Do you offer wheelchair-accessible vehicles?",
      answer: "Yes! We have a fleet of wheelchair-accessible vehicles equipped to safely transport passengers who use wheelchairs or other mobility devices."
    },
    {
      id: 4,
      question: "What areas do you serve?",
      answer: "We serve 16 counties across Central Georgia including Upson, Lamar, Pike, Butts, Spalding, Monroe, Taylor, Talbot, Harris, Meriwether, Troup, Muscogee, Coweta, Fayette, Henry, and Clayton counties. We also provide out-of-state transportation for specialized medical appointments."
    },
    {
      id: 5,
      question: "How far in advance should I book?",
      answer: "For Medicaid rides, we recommend booking at least 3-5 business days in advance. For private pay services, we can often accommodate same-day requests based on availability."
    },
    {
      id: 6,
      question: "Do you offer Stretcher Vehicles?",
      answer: "Yes! We have a fleet of Stretcher-accessible vehicles equipped to safely transport passengers."
    }
  ],
  
  insuranceProviders: [
    { name: "Georgia Medicaid", logo: "shield-plus" },
    { name: "Peach State Health Plan", logo: "heart-pulse" },
    { name: "CareSource Georgia", logo: "hospital" },
    { name: "Amerigroup Georgia", logo: "activity" },
    { name: "WellCare of Georgia", logo: "stethoscope" },
    { name: "Medicare", logo: "heart" }
  ],
  
  stats: [
    { number: "15", label: "Vehicles" },
    { number: "30K+", label: "Rides Completed" },
    { number: "10+", label: "Years Experience" },
    { number: "98%", label: "On-Time Rate" }
  ]
};

